import { Button } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const DeprecationCallout: React.FC = () => {
  const { navigation } = useNavigation()

  return (
    <Callout
      type="warning"
      title={i18n.t('competencies_v3.deprecation_callout.title')}
      description={i18n.t(
        'competencies_v2.assessments.deprecation_callout_employee_profile.description'
      )}
      action={
        <Button.Router
          to={{
            pathname: navigation.competencies.assessments.fullPath(),
          }}
          type="secondary"
        >
          {i18n.t(
            'competencies_v2.assessments.deprecation_callout_employee_profile.go_to_competencies_button'
          )}
        </Button.Router>
      }
    />
  )
}
